import axiosHttp from "services/axiosHttp";
import { message } from "antd";
import { MEAL_BASE_URL } from "configs/AppConfig";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");


//action
export const creatMeal = createAsyncThunk("creatMeal", async ( data,{rejectWithValue}) => {
	try {
		const response = await axiosHttp.post(`${MEAL_BASE_URL}menu-item`, data);
		message.success("Meal item has been created successfully!");
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const MealCreateSlice = createSlice({
	name: "MealCreateSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	
	reducers: {
		resetMealCreateState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},
	
	extraReducers: (builder) => {
		builder.addCase(creatMeal.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(creatMeal.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(creatMeal.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetMealCreateState } = MealCreateSlice.actions;
export default MealCreateSlice.reducer;
